module.exports = __webpack_public_path__ + "static/media/open.a2b3265e.svg";